import { connect } from "react-redux";
import ActionsList from "./ActionsList";

import {
  init,
  getReferentielsList
} from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		actionsList: state.actions.actionsList,
		page: state.actions.page,
		pages: state.actions.pages,
		pageSize: state.actions.pageSize,
		nbItems: state.actions.actionsList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "actions"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ActionsList);


// WEBPACK FOOTER //
// src/containers/admin/actions/ActionsContainer.js